import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import StatsSection from "./components/StatsSection";
import EventSimulator from "./components/EventSimulator";
import GallerySection from "./components/GallerySection";
import TestimonialsSection from "./components/TestimonialsSection";
import TeamSection from "./components/TeamSection";
import FaqSection from "./components/FaqSection";
import Footer from "./components/Footer";
import Chatbot from "./components/Chatbot";
import Dashboard from "./pages/Dashboard";
import LeadDetail from "./pages/LeadDetail";
import CalendarPage from "./pages/CalendarPage";
import PricingPage from "./pages/PricingPage";
import AdminLogin from "./pages/AdminLogin";
import { AuthLayout } from "./context/AuthContext";
import { ProtectedRoute } from "./components/ProtectedRoute";
import "./lib/api";

const LandingPage = () => (
  <div className="bg-[#0a0a0a] min-h-screen">
    <Navbar />
    <main>
      <HeroSection />
      <StatsSection />
      <EventSimulator />
      <GallerySection />
      <TestimonialsSection />
      <TeamSection />
      <FaqSection />
      <Footer />
    </main>
    <Chatbot />
  </div>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/admin" element={<AuthLayout />}>
            <Route path="login" element={<AdminLogin />} />
            <Route element={<ProtectedRoute />}>
              <Route index element={<Dashboard />} />
              <Route path="leads/:id" element={<LeadDetail />} />
              <Route path="calendario" element={<CalendarPage />} />
              <Route path="precos" element={<PricingPage />} />
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
